/* ==========================================================================

   ToyznKidz Master Interaction Script – ToyznKidz Edition

   - Bulletproof AJAX Cart Integration

   - Dynamic Cart Drawer Re-rendering from /cart.js

   - Milestone Progress Calculation (1.500 / 2.500 / 3.500 TL)

   - Real-time Item Stepper (+ / -) & Line Item Removal

   - Cart Attributes Auto-Save (Gizli Koli, Fiyatsız Fatura, Hediye Notu)

   ========================================================================== */



document.addEventListener('DOMContentLoaded', function () {

  'use strict';



  function getCartDrawer() {
    return document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
  }

  function openCartDrawer() {
    const drawer = getCartDrawer();
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer = getCartDrawer();
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
    }
    document.body.style.overflow = '';
  }

  window.getCartDrawer = getCartDrawer;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;



  // 1. Format Currency Helper (Turkish Lira Format)

  function formatMoney(cents) {

    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;

    const amount = (cents / 100).toFixed(2).replace('.', ',');

    const parts = amount.split(',');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return parts.join(',') + ' TL';

  }



  // 2. Dynamic Cart Drawer UI Re-renderer

  function updateCartDrawerUI(cart) {

    if (!cart) return;



    // Update all badge counters
    const badges = document.querySelectorAll('.cart-counter-bubble, .cart-badge-count, .mobile-cart-badge, #CartDrawerCount, .cart-count-badge');
    badges.forEach(b => {
      if (b.id === 'CartDrawerCount' || b.classList.contains('cart-count-badge')) {
        b.textContent = '(' + (cart.item_count || 0) + ')';
      } else {
        b.textContent = cart.item_count || 0;
      }
    });

    const emptyBox = document.querySelector('.cart-drawer-empty');
    const filledBox = document.querySelector('.cart-drawer-filled');
    const itemsList = document.querySelector('.cart-items-list');
    const subtotalEl = document.querySelector('.cart-subtotal-price, #CartDrawerSubtotal');
    const checkoutBtn = document.querySelector('.cart-checkout-btn');
    const shippingNoteStrong = document.querySelector('.cart-shipping-note strong');



    // Milestones Calculation (Removed - Shipping is unconditionally free)
    const milestoneBar = document.querySelector('.cart-milestone-bar');
    const milestoneText = document.querySelector('.cart-milestone-text');
    if (milestoneBar) milestoneBar.style.display = 'none';
    if (milestoneText) milestoneText.style.display = 'none';



    // Handle Empty vs Filled
    if (!cart.items || cart.items.length === 0) {
      if (emptyBox) {
        emptyBox.classList.remove('is-hidden');
        emptyBox.style.setProperty('display', 'flex', 'important');
      }
      if (filledBox) {
        filledBox.classList.add('is-hidden');
        filledBox.style.setProperty('display', 'none', 'important');
      }
      if (itemsList) itemsList.innerHTML = '';
      if (subtotalEl) subtotalEl.textContent = '0,00 TL';
      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.pointerEvents = 'none';
      }
      if (shippingNoteStrong) {
        shippingNoteStrong.textContent = 'Hesaplama Kasa Adımında';
        shippingNoteStrong.style.color = '#0F172A';
      }
      return;
    }

    // Cart has items!
    if (emptyBox) {
      emptyBox.classList.add('is-hidden');
      emptyBox.style.setProperty('display', 'none', 'important');
    }
    if (filledBox) {
      filledBox.classList.remove('is-hidden');
      filledBox.style.setProperty('display', 'block', 'important');
    }
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '1';
      checkoutBtn.style.pointerEvents = 'auto';
    }
    if (shippingNoteStrong) {
      const isFree = window.themeShippingSettings ? window.themeShippingSettings.shippingIsFree : true;
      const threshold = window.themeShippingSettings ? (window.themeShippingSettings.threshold * 100) : 0;
      if (isFree || threshold === 0 || total >= threshold) {
        shippingNoteStrong.textContent = 'ÜCRETSİZ';
        shippingNoteStrong.style.color = '#16A34A';
      } else {
        shippingNoteStrong.textContent = 'Kasa Adımında Hesaplanır';
        shippingNoteStrong.style.color = '#0F172A';
      }
    }



    // Render Items

    if (itemsList) {

      let html = '';

      cart.items.forEach(item => {

        const imgSrc = item.image || (item.featured_image ? item.featured_image.url : '');

        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Varsayılan' ? `<span class="cart-item-variant" style="font-size: 11px; color: #757575;">${item.variant_title}</span>` : '';



        html += `

          <div class="cart-item-row" data-line-item-key="${item.key}">

            <div class="cart-item-img">

              ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" width="70" height="70" style="width:100%;height:100%;object-fit:contain;">` : ''}

            </div>

            <div class="cart-item-details">

              <div class="cart-item-title"><a href="${item.url || '#'}">${item.product_title || item.title}</a></div>

              ${variantTitle}

              <div class="cart-item-price">${formatMoney(item.final_line_price || (item.price * item.quantity))}</div>



              <div class="cart-item-qty-row">

                <div class="cart-qty-pill">

                  <button type="button" class="cart-qty-btn" data-qty-change="-1" data-key="${item.key}">&minus;</button>

                  <span class="cart-qty-val">${item.quantity}</span>

                  <button type="button" class="cart-qty-btn" data-qty-change="1" data-key="${item.key}">&plus;</button>

                </div>

                <span class="cart-item-remove-link" data-remove-key="${item.key}">Kaldır</span>

              </div>

            </div>

          </div>

        `;

      });

      itemsList.innerHTML = html;

    }



    if (subtotalEl) {

      subtotalEl.textContent = formatMoney(cart.total_price);

    }

  }



  // 3. Drawer Open & Close Triggers

  document.addEventListener('click', function (e) {

    if (e.target.closest('[data-drawer-open], .cart-pill-btn, .mobile-cart-trigger, .circular-icon-btn[aria-label*="Sepet"]')) {

      e.preventDefault();

      fetch('/cart.js')

        .then(r => r.json())

        .then(cart => {

          updateCartDrawerUI(cart);

          openCartDrawer();

        })

        .catch(() => openCartDrawer());

      return;

    }



    const closeBtn = e.target.closest('[data-drawer-close], .cart-drawer-close-btn, .cart-drawer-overlay');
    if (closeBtn && !closeBtn.getAttribute('href')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
  });

  // ESC Key to Close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      const drawer = getCartDrawer();
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeCartDrawer();
      }
    }
  });



  // 4. Universal AJAX Add To Cart via Event Delegation

  document.addEventListener('submit', function (e) {

    const form = e.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) return;



    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');

    if (submitBtn && submitBtn.disabled) return;



    const originalText = submitBtn ? submitBtn.innerHTML : 'Sepete Ekle';

    if (submitBtn) {

      submitBtn.disabled = true;

      submitBtn.innerHTML = '<span>Ekleniyor...</span>';

    }



    const formData = new FormData(form);



    fetch('/cart/add.js', {

      method: 'POST',

      body: formData,

      headers: {

        'X-Requested-With': 'XMLHttpRequest',

        'Accept': 'application/json'

      }

    })

    .then(async res => {

      const data = await res.json();

      if (!res.ok) {

        throw new Error(data.description || data.message || 'Ürün eklenemedi');

      }

      return data;

    })

    .then(addedItem => {

      if (submitBtn) {

        submitBtn.innerHTML = '<span>Eklendi ✓</span>';

      }



      // Fetch full cart to re-render drawer with newly added item

      return fetch('/cart.js').then(r => r.json());

    })

    .then(cart => {

      updateCartDrawerUI(cart);

      setTimeout(() => {

        openCartDrawer();

        if (submitBtn) {

          submitBtn.innerHTML = originalText;

          submitBtn.disabled = false;

        }

      }, 250);

    })

    .catch(err => {

      console.error('Sepete ekleme hatası:', err);

      if (submitBtn) {

        submitBtn.innerHTML = `<span>Hata, ${err.message || 'Eklenemedi'}</span>`;

        setTimeout(() => {

          submitBtn.innerHTML = originalText;

          submitBtn.disabled = false;

        }, 2000);

      }

    });

  });



  // 5. Adet Değiştirme (+ / -) ve Satır Silme

  document.addEventListener('click', function (e) {

    const qtyBtn = e.target.closest('[data-qty-change]');

    if (qtyBtn) {

      e.preventDefault();

      const change = parseInt(qtyBtn.dataset.qtyChange, 10);

      const key = qtyBtn.dataset.key;

      const valSpan = qtyBtn.parentElement.querySelector('.cart-qty-val');

      let currentVal = parseInt(valSpan.textContent, 10) || 1;

      let newVal = Math.max(0, currentVal + change);



      fetch('/cart/change.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

        body: JSON.stringify({ id: key, quantity: newVal })

      })

      .then(r => r.json())

      .then(cart => {

        updateCartDrawerUI(cart);

      })

      .catch(err => {

        console.error('Adet değiştirme hatası:', err);

      });

      return;

    }



    const removeLink = e.target.closest('[data-remove-key]');

    if (removeLink) {

      e.preventDefault();

      const key = removeLink.dataset.removeKey;

      fetch('/cart/change.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

        body: JSON.stringify({ id: key, quantity: 0 })

      })

      .then(r => r.json())

      .then(cart => {

        updateCartDrawerUI(cart);

      })

      .catch(err => {

        console.error('Satır silme hatası:', err);

      });

      return;

    }

  });



  // 6. Gifting Attributes Auto-save

  document.addEventListener('change', function (e) {

    if (e.target.matches('input[name*="attributes["], textarea[name*="attributes["]')) {

      const form = e.target.closest('.cart-drawer-panel');

      if (!form) return;

      const inputs = form.querySelectorAll('input[name*="attributes["], textarea[name*="attributes["]');

      const attributes = {};

      inputs.forEach(inp => {

        const match = inp.name.match(/\[([^\]]+)\]/);

        if (match && match[1]) {

          if (inp.type === 'checkbox') {

            attributes[match[1]] = inp.checked ? inp.value : '';

          } else {

            attributes[match[1]] = inp.value;

          }

        }

      });



      fetch('/cart/update.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

        body: JSON.stringify({ attributes })

      }).catch(() => {});

    }

  });



  // Initial cart sync on load

  fetch('/cart.js')

    .then(r => r.json())

    .then(cart => updateCartDrawerUI(cart))

    .catch(() => {});





    // 7. PDP Interactivity (Thumbnails, Magnifier, Lightbox, Stepper, Accordions, Sticky Bar)
  let currentLightboxIndex = 0;
  let galleryThumbBtns = Array.from(document.querySelectorAll('.product-thumb-btn'));

  function getGalleryThumbs() {
    return Array.from(document.querySelectorAll('.product-thumb-btn'));
  }

  const lightboxModal = document.getElementById('ProductLightboxModal');
  const lightboxImg = document.getElementById('LightboxImage');
  const lightboxCounter = document.getElementById('LightboxCounter');

  const lbImageWrap = document.querySelector('.lightbox-image-wrap');
  const lbZoomToggleBtn = document.getElementById('LightboxZoomToggleBtn');
  const lbZoomBtnText = document.getElementById('LightboxZoomBtnText');

  function set2xZoom(isZoomed) {
    if (!lbImageWrap) return;
    if (isZoomed) {
      lbImageWrap.classList.add('is-zoomed');
      if (lbZoomToggleBtn) lbZoomToggleBtn.classList.add('is-active');
      if (lbZoomBtnText) lbZoomBtnText.textContent = 'Ekrana Sığdır (%100)';
    } else {
      lbImageWrap.classList.remove('is-zoomed');
      lbImageWrap.scrollLeft = 0;
      lbImageWrap.scrollTop = 0;
      if (lbZoomToggleBtn) lbZoomToggleBtn.classList.remove('is-active');
      if (lbZoomBtnText) lbZoomBtnText.textContent = '2 Kat Büyüt (2x Zoom)';
    }
  }

  function toggle2xZoom() {
    if (!lbImageWrap) return;
    const currentlyZoomed = lbImageWrap.classList.contains('is-zoomed');
    set2xZoom(!currentlyZoomed);
  }

  function updateLightbox(index) {
    const thumbs = getGalleryThumbs();
    if (!thumbs.length) return;
    set2xZoom(false); // Reset to fit mode on slide change
    currentLightboxIndex = (index + thumbs.length) % thumbs.length;
    const targetThumb = thumbs[currentLightboxIndex];
    if (targetThumb && lightboxImg) {
      const zoomSrc = targetThumb.dataset.zoomSrc || targetThumb.dataset.fullSrc;
      lightboxImg.src = zoomSrc;
      if (lightboxCounter) {
        lightboxCounter.textContent = (currentLightboxIndex + 1) + ' / ' + thumbs.length;
      }
    }
  }

  function openLightbox(index) {
    if (!lightboxModal) return;
    set2xZoom(false);
    updateLightbox(index || 0);
    lightboxModal.classList.add('is-active');
    lightboxModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightboxModal) return;
    set2xZoom(false);
    lightboxModal.classList.remove('is-active');
    lightboxModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Click on Featured Media Card opens Lightbox
  const featuredCard = document.getElementById('ProductFeaturedMediaCard');
  if (featuredCard) {
    featuredCard.addEventListener('click', function(e) {
      openLightbox(currentLightboxIndex);
    });
    featuredCard.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(currentLightboxIndex);
      }
    });
  }

  // Lightbox Controls
  const lbCloseBtn = document.getElementById('LightboxCloseBtn');
  const lbBackdrop = document.getElementById('LightboxBackdrop');
  const lbPrevBtn = document.getElementById('LightboxPrevBtn');
  const lbNextBtn = document.getElementById('LightboxNextBtn');

  if (lbCloseBtn) lbCloseBtn.addEventListener('click', closeLightbox);
  if (lbBackdrop) lbBackdrop.addEventListener('click', closeLightbox);
  if (lbPrevBtn) lbPrevBtn.addEventListener('click', function(e) { e.stopPropagation(); updateLightbox(currentLightboxIndex - 1); });
  if (lbNextBtn) lbNextBtn.addEventListener('click', function(e) { e.stopPropagation(); updateLightbox(currentLightboxIndex + 1); });
  if (lbZoomToggleBtn) lbZoomToggleBtn.addEventListener('click', function(e) { e.stopPropagation(); toggle2xZoom(); });
  if (lightboxImg) lightboxImg.addEventListener('click', function(e) { e.stopPropagation(); toggle2xZoom(); });

  // Keyboard navigation for Lightbox
  document.addEventListener('keydown', function(e) {
    if (!lightboxModal || !lightboxModal.classList.contains('is-active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') updateLightbox(currentLightboxIndex - 1);
    if (e.key === 'ArrowRight') updateLightbox(currentLightboxIndex + 1);
  });

  document.addEventListener('click', function(e) {
    // Thumbnail click
    const thumbBtn = e.target.closest('.product-thumb-btn');
    if (thumbBtn) {
      document.querySelectorAll('.product-thumb-btn').forEach(b => b.classList.remove('is-active'));
      thumbBtn.classList.add('is-active');
      
      const idx = parseInt(thumbBtn.dataset.index, 10);
      if (!isNaN(idx)) currentLightboxIndex = idx;
      
      const mainImg = document.getElementById('ProductMainImage') || document.getElementById('MainProductImage');
      if (mainImg && thumbBtn.dataset.fullSrc) {
        mainImg.src = thumbBtn.dataset.fullSrc;
        if (thumbBtn.dataset.zoomSrc) {
          mainImg.setAttribute('data-zoom-src', thumbBtn.dataset.zoomSrc);
        }
      }
    }

    // PDP Stepper (+ / -)
    const pQtyBtn = e.target.closest('.p-qty-btn');
    if (pQtyBtn) {
      const step = parseInt(pQtyBtn.dataset.step, 10) || 1;
      const inp = pQtyBtn.parentElement.querySelector('.p-qty-input');
      if (inp) {
        let val = parseInt(inp.value, 10) || 1;
        inp.value = Math.max(1, val + step);
      }
    }

    // Accordion Tab Toggle
    const tabTrigger = e.target.closest('.collapsible-tab-trigger');
    if (tabTrigger) {
      const tabItem = tabTrigger.closest('.collapsible-tab-item');
      if (tabItem) {
        tabItem.classList.toggle('is-open');
      }
    }
  });


  // 6. PDP Variant Picker Controller
  function initVariantPicker() {
    const picker = document.getElementById('ProductVariantPicker');
    const variantsScript = document.querySelector('.product-variants-json');
    if (!picker || !variantsScript) return;

    let variantsData = [];
    try {
      variantsData = JSON.parse(variantsScript.textContent);
    } catch (err) {
      console.error('Variant JSON parse error:', err);
      return;
    }

    if (!Array.isArray(variantsData) || variantsData.length === 0) return;

    picker.addEventListener('change', function (e) {
      const radio = e.target.closest('.variant-pill-input');
      if (!radio) return;

      // Update current label text
      const group = radio.closest('.variant-option-group');
      if (group) {
        const valSpan = group.querySelector('.current-option-val');
        if (valSpan) valSpan.textContent = radio.value;

        // Update pill UI styles
        const labels = group.querySelectorAll('.variant-pill-label');
        labels.forEach(lbl => {
          lbl.classList.remove('is-selected');
          lbl.style.borderColor = '#E2E8F0';
          lbl.style.background = '#FFFFFF';
          lbl.style.color = '#0F172A';
        });
        const activeLabel = radio.closest('.variant-pill-label');
        if (activeLabel) {
          activeLabel.classList.add('is-selected');
          activeLabel.style.borderColor = '#B81D4F';
          activeLabel.style.background = '#FDF2F4';
          activeLabel.style.color = '#B81D4F';
        }
      }

      // Collect all selected options
      const selectedOptions = [];
      const optionGroups = picker.querySelectorAll('.variant-option-group');
      optionGroups.forEach(grp => {
        const checked = grp.querySelector('.variant-pill-input:checked');
        if (checked) {
          selectedOptions.push(checked.value);
        }
      });

      // Find matching variant
      const matched = variantsData.find(v => {
        return selectedOptions.every((optVal, idx) => {
          return v.options[idx] === optVal;
        });
      });

      if (!matched) return;

      // Update Variant ID input fields
      const mainIdInput = document.getElementById('MainProductVariantId');
      if (mainIdInput) mainIdInput.value = matched.id;

      const stickyIdInput = document.getElementById('StickyProductVariantId');
      if (stickyIdInput) stickyIdInput.value = matched.id;

      // Update Prices
      const currentPriceEl = document.querySelector('.product-current-price');
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(matched.price);

      const stickyPriceEl = document.getElementById('StickyAtcPrice');
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(matched.price);

      const comparePriceEl = document.querySelector('.product-compare-price');
      const saveBadge = document.querySelector('.product-save-badge');
      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        if (comparePriceEl) {
          comparePriceEl.textContent = formatMoney(matched.compare_at_price);
          comparePriceEl.style.display = 'inline';
        }
        if (saveBadge) {
          const pct = Math.round(((matched.compare_at_price - matched.price) / matched.compare_at_price) * 100);
          saveBadge.textContent = '-%' + pct;
          saveBadge.style.display = 'inline';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
      }

      // Update Button State
      const atcBtn = document.getElementById('MainAddToCartBtn');
      const atcText = document.getElementById('MainAddToCartText');
      if (atcBtn) {
        if (matched.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.style.opacity = '1';
          atcBtn.style.cursor = 'pointer';
          if (atcText) atcText.innerHTML = 'Sepete Ekle &bull; ' + formatMoney(matched.price);
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          atcBtn.style.opacity = '0.55';
          atcBtn.style.cursor = 'not-allowed';
          if (atcText) atcText.textContent = 'Tükendi';
        }
      }

      // Update URL with ?variant=ID without reloading
      if (window.history && window.history.replaceState) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', newUrl.href);
      }
    });
  }

  initVariantPicker();

  // Sticky ATC Bar Scroll Trigger Tolerant
  const stickyBarEl = document.getElementById('StickyAddToCart') || document.getElementById('StickyAtcBar');
  const mainBuyFormEl = document.getElementById('MainProductForm');
  if (mainBuyFormEl && stickyBarEl) {
    window.addEventListener('scroll', function() {
      const rect = mainBuyFormEl.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBarEl.setAttribute('aria-hidden', 'false');
        stickyBarEl.classList.add('is-visible');
      } else {
        stickyBarEl.setAttribute('aria-hidden', 'true');
        stickyBarEl.classList.remove('is-visible');
      }
    }, { passive: true });
  }

});
